import { writable } from 'svelte/store';

export const isMenuActive = writable(false);

export const isCookieAccepted = writable(false); 

export const isMeditationOn = writable(false); 

export const overlayContent = writable(null); 

export const scrollY = writable(0);

export const loading = writable(false)

export const footerHeight = writable(0)

export const almanacOverlayActive = writable(false)

export const lighboxSlideActive = writable(null) // null to hide, or {...items} object

const audioPlayerdefaults = {
  pagePath: null,
  src: null,
  paused: true,
  position: 2, // values > 1 tells AudioPlayerLayer not to autoplay
  duration: 0,
  title: ""
}

function createAudioPlayer(defaults) {
  const { subscribe, set, update } = writable({...defaults});

  return {
    subscribe,
    load: data => set( { ...data, paused: true, position: 0 } ),
    togglePlay: () => update( s => ({ ...s, paused: !s.paused }) ),
    reset: data => set({ ...audioPlayerdefaults}),
    set,
    update
  };
}

export const audioPlayer = createAudioPlayer(audioPlayerdefaults)